export default __webpack_public_path__ + "static/media/premium_beta_alternate.9ea83ead.svg";